export interface BetHistory {
  providerId: string;
  providerName: string;
  status: string;
  errorDescription: string;
  bets: BetInfo;
  page: number;
  pageSize: number;
  totalRecords: number;
}

export interface BetInfo {
  userName: string;
  sportName: string;
  eventName: string;
  betTime?: string;
  currency?: string;
  betType?: string;
  resultTime?: string;
  marketType: string;
  marketName: string;
  lapsedTime?: number;
  odds: number;
  bet_type: string;
  stake: number;
  sessionOutcome: number;
  transactionId: string;
  betId: string;
  netAmount?: number;
  rate?: number;
  status: string;
  betStatus?: string;
  runnerName?: string;
  marketResult?: MarketResult;
  errorDescription?: string;
}

export interface MarketResult {
  RunnerId: string;
  RunnerName: string;
  SessionOutcome: number;
  ResultTime: string;
}

export interface BetReq {
  betOdds: number;
  betStake: number;
  betTime: number;
  betType: string;
  runnerName: string;
  sessionOutcome: number;
}

export interface BetResult {
  resultTime: number;
  runnerName: string;
  sessionOutcome: number;
  winAmount: number;
}

export const Category = [
  { id: "LIVE", name: "NON SRL" },
  { id: "VIRTUAL", name: "SRL" },
];